import {
  Badge,
  Box,
  Button,
  Center,
  Flex,
  Heading,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spacer,
  Stack,
  Text,
  useToast,
} from '@chakra-ui/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { TbReload } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../Hooks/Zustand/Store';
import { addDocumentFirebase, getCollectionFirebase } from '../../Api/firebaseApi';
import BackButtons from '../../Components/Buttons/BackButtons';
import DynamicButton from '../../Components/Buttons/DynamicButton';
import ImageComponent from '../../Components/Image/ImageComponent';


function ProjectsPage() {
  const globalState = useUserStore();
  const [data, setData] = useState([]);
  const [title, setTitle] = useState('');
  const [modalNew, setModalNew] = useState(false);
  const [filterOwner, setFilterOwner] = useState(false)
  const toast = useToast()
  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 8;


  const navigate = useNavigate();


  const getData = () => {
    let conditions = [
      {
        field: 'companyId',
        operator: '==',
        value: globalState.currentCompany,
      },
      {
        field: 'users',
        operator: 'array-contains',
        value: globalState.uid,
      },
    ];
    const sortBy = { field: 'createdAt', direction: 'desc' };
    const limitValue = startIndex + itemsPerPage;

    if (filterOwner === true) {
      conditions = [
        { field: 'companyId', operator: '==', value: globalState.currentCompany },
      ];
    }

    getCollectionFirebase('projects', conditions, sortBy, limitValue)
      .then((x) => {
        setData(x);
      })
      .catch((error) => {
        toast({
          title: 'Deoapp.com',
          description: error.message,
          status: 'error',
          position: 'top-right',
          duration: 3000,
          isClosable: true,
        });
      });
  };
  const handleOpenFilter = () => {
    if (globalState.roleCompany !== 'owner') {
      toast({
        title: 'Alert!',
        description: 'You dont have access to filter this button / only owner.',
        status: 'warning',
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    setFilterOwner((prevFilterOwner) => !prevFilterOwner);
  };

  useEffect(() => {
    getData();
    return () => {
      setData();
    };
  }, [globalState?.currentCompany, startIndex, filterOwner]);

  const handleNewProject = () => {
    setModalNew(true);
  };

  const createNewProject = () => {
    const data = {
      name: title,
      companyId: globalState.currentCompany,
      lastUpdated: new Date(),
      owner: [globalState.uid],
      users: [globalState.uid],
    };
    addDocumentFirebase('projects', data, globalState.currentCompany).then(
      (x) => {
        navigate(`/configuration/project/${x}`);
      }
    );
  };

  const handleLoadMore = () => {
    setStartIndex((prev) => prev + itemsPerPage);
  };



  return (
    <Stack p={[1, 1, 5]} spacing={5}>
      <HStack flexDirection={['column', 'row', 'row']}>
        <BackButtons />
        <Heading size={'md'}>Projects</Heading>
        <Spacer />

        <DynamicButton
          title={'See all'}
          action={'read'}
          onClick={handleOpenFilter}
        />

        <DynamicButton
          action={'create'}
          title="Project"
          onClick={handleNewProject}
        />
        <DynamicButton
          action={'custom'}
          icon={TbReload}
          variant="solid"
          title="Configuration"
          color="blue"
          onClick={() => window.location.reload()}
        />
      </HStack>

      {data?.length > 0 ? (
        <SimpleGrid columns={{ base: 1, lg: 4 }} p="2" spacing={4} my={5}>
          {data.map((x, i) => (
            <Stack
              key={i}
              p="5"
              shadow="base"
              minH="100px"
              // bg={'white'}
              borderRadius={'md'}
              onClick={() => navigate(`${x.id}`)}
              cursor="pointer"
            >
              <ImageComponent image={x.image} name={x.name} />
              <Spacer />

              <Stack>
                <Text fontWeight={'bold'}>{x.name}</Text>
                <Text fontSize="3xs">ID: {x.id}</Text>
              </Stack>

              <SimpleGrid columns={{ base: 2, lg: 3 }} textAlign="center">
                <Box shadow="base" borderRadius="md" m="1" p="1">
                  <Text fontSize="xs">Manager</Text>
                  <Text fontWeight={500}>
                    {x?.managers?.length ? x.managers.length : 0}
                  </Text>
                </Box>
                <Box shadow="base" borderRadius="md" m="1" p="1">
                  <Text fontSize="xs">Users</Text>
                  <Text fontWeight={500}>
                    {x?.users?.length ? x.users.length : 0}
                  </Text>
                </Box>
                <Box shadow="base" borderRadius="md" m="1" p="1">
                  <Text fontSize="xs">Modules</Text>
                  <Text fontWeight={500}>
                    {x?.modules?.length ? x.modules.length : 0}
                  </Text>
                </Box>
              </SimpleGrid>
              <Flex overflowY="auto">
                {x.modules?.map((z, index) => (
                  <Badge
                    key={index}
                    colorScheme="green"
                    m="1"
                    borderRadius={'md'}
                  >
                    {z}
                  </Badge>
                ))}
              </Flex>
              <Text fontSize="2xs" textAlign={'end'}>
                Created: {moment(x?.createdAt?.seconds * 1000).format('LLL')}
              </Text>
            </Stack>
          ))}
        </SimpleGrid>


      ) : (
        <Center my={5}>
          <Stack align={'center'}>
            <Text fontWeight={500} color={'gray.500'}>
              No Project Data
            </Text>
            <Text fontWeight={500} color={'gray.500'}>
              Please Create a New Project
            </Text>
          </Stack>
        </Center>
      )}

      <Stack alignItems={'center'} justifyContent="center" py={5}>
        <Box>
          {data?.length > startIndex && (
            <Button onClick={handleLoadMore} size="sm">
              Load More
            </Button>
          )}
        </Box>
      </Stack>

      <Modal isOpen={modalNew} onClose={() => setModalNew(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Project</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Lorem count={2} /> */}
            <Input type="text" onChange={(e) => setTitle(e.target.value)} />
          </ModalBody>

          <ModalFooter>
            <DynamicButton
              action={'create'}
              onClick={() => createNewProject()}
              title="Save"
              variant={'solid'}
            />
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Stack>
  );
}

export default ProjectsPage;
